// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_solution_reviews.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { CheckCaptureSolutionReviewAccessRequest, CheckCaptureSolutionReviewAccessResponse, DecideCaptureSolutionReviewRequest, DecideCaptureSolutionReviewResponse, GetCaptureSolutionReviewRequest, GetCaptureSolutionReviewResponse, ListCaptureSolutionReviewsRequest, ListCaptureSolutionReviewsResponse, RefreshCaptureSolutionReviewRequest, RefreshCaptureSolutionReviewResponse } from "./capture_solution_reviews_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * @generated from service mono.projectdata.v1.CaptureSolutionReviewsService
 */ export const CaptureSolutionReviewsService = {
    typeName: "mono.projectdata.v1.CaptureSolutionReviewsService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.CaptureSolutionReviewsService.ListCaptureSolutionReviews
     */ listCaptureSolutionReviews: {
            name: "ListCaptureSolutionReviews",
            I: ListCaptureSolutionReviewsRequest,
            O: ListCaptureSolutionReviewsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.CaptureSolutionReviewsService.GetCaptureSolutionReview
     */ getCaptureSolutionReview: {
            name: "GetCaptureSolutionReview",
            I: GetCaptureSolutionReviewRequest,
            O: GetCaptureSolutionReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.CaptureSolutionReviewsService.DecideCaptureSolutionReview
     */ decideCaptureSolutionReview: {
            name: "DecideCaptureSolutionReview",
            I: DecideCaptureSolutionReviewRequest,
            O: DecideCaptureSolutionReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.CaptureSolutionReviewsService.RefreshCaptureSolutionReview
     */ refreshCaptureSolutionReview: {
            name: "RefreshCaptureSolutionReview",
            I: RefreshCaptureSolutionReviewRequest,
            O: RefreshCaptureSolutionReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * Authorization-only callback used by pangaea; no evidence content is returned.
     *
     * @generated from rpc mono.projectdata.v1.CaptureSolutionReviewsService.CheckCaptureSolutionReviewAccess
     */ checkCaptureSolutionReviewAccess: {
            name: "CheckCaptureSolutionReviewAccess",
            I: CheckCaptureSolutionReviewAccessRequest,
            O: CheckCaptureSolutionReviewAccessResponse,
            kind: MethodKind.Unary
        }
    }
};
